import { render, staticRenderFns } from "./NewsFeedItem.vue?vue&type=template&id=0aa5f2bc&scoped=true"
import script from "./NewsFeedItem.vue?vue&type=script&lang=js"
export * from "./NewsFeedItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa5f2bc",
  null
  
)

export default component.exports